//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment';
//@end

//@import components
import SatisfactionSummaryModule from 'app_components/modules/campus/academic/satisfactionSummary'
import ClassesTaugthModule from 'app_components/modules/campus/academic/classesTaught'
import CoursesTaughtModule from 'app_components/modules/campus/academic/coursesTaught'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../statsModule.scss'

// @ADD Component types
interface IStatsModuleLayoutProps { }

const StatsModuleLayout: React.FC<IStatsModuleLayoutProps> = (props) => {

  const { t } = useTranslation()

  return (
    <div className='stats_module-component'>
      <div className="title">
        {t("modules.stats_module.title")}
      </div>
      <hr />
      <div className="container-stats">
        <div>
          <SatisfactionSummaryModule isVirtual={true} label='Virtual' currentYear={moment().year()} />
        </div>
        <div>
          <SatisfactionSummaryModule isVirtual={false} label='Presencial / En linea' currentYear={moment().year()} />
        </div>
        <div>
          <ClassesTaugthModule />
        </div>
        <div>
          <CoursesTaughtModule />
        </div>
      </div>
    </div>
  )
}

export default StatsModuleLayout
